import { useEffect, useRef, useState } from "react";
import styles from "./styles.module.scss";
import { FC, Props, Option } from "./typings";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisVertical } from "@fortawesome/free-solid-svg-icons";
import VerifyIcon from "assets/icons/status.svg?react";
import NoteIcon from "assets/icons/sticky-note.svg?react";
import Dropdown from "components/OptionsCard/Dropdown";
import AttachmentIcon from "assets/icons/attachments.svg?react";
import WebIcon from "assets/icons/link.svg?react";
import { useTranslation } from "react-i18next";

const MenuCell: FC<Props> = ({
  element,
  scrollWrapper,
  onVerify,
  onAddAttachment,
  onAddNote,
}) => {
  const { t } = useTranslation();
  const [showOptions, setShowOptions] = useState(false);
  const refWrapper = useRef<HTMLDivElement>(null);
  const [options, setOptions] = useState<Option[]>([]);

  const openKRSSite = () => {
    window.open(
      "https://wyszukiwarka-krs.ms.gov.pl/",
      "_blank",
      "noopener,noreferrer"
    );
  };

  useEffect(() => {
    const opt = [
      {
        name: t("verifyModal.verifyData"),
        Icon: VerifyIcon,
        callback: () => {
          onVerify?.(element);
        },
        additional: false,
        isEnabled: true,
        canMultiple: true,
      },
      {
        name: t("admin.openKrsPage"),
        Icon: WebIcon,
        callback: () => {
          openKRSSite();
        },
        additional: false,
        isEnabled: true,
        canMultiple: true,
      },
      {
        name: t("notes.create"),
        Icon: NoteIcon,
        callback: () => {
          onAddNote?.(element);
        },
        additional: false,
        isEnabled: true,
        canMultiple: true,
      },
      {
        name: t("documents.addAttachment"),
        Icon: AttachmentIcon,
        callback: () => {
          onAddAttachment?.(element);
        },
        additional: false,
        isEnabled: true,
        canMultiple: true,
      },
    ];

    setOptions(opt);
  }, [showOptions]);

  return (
    <div className={styles.cell}>
      <div
        onClick={() => {
          setShowOptions(!showOptions);
        }}
        ref={refWrapper}
        className={styles.hover}
      >
        <FontAwesomeIcon icon={faEllipsisVertical} />
      </div>
      {showOptions && (
        <Dropdown
          toggle={() => setShowOptions(false)}
          options={options}
          refWrapper={refWrapper}
          rightSide={true}
          scrollWrapper={scrollWrapper}
          showOptions={showOptions}
          selectedElements={[]}
          setSelectedElements={() => {}}
        />
      )}
    </div>
  );
};

export default MenuCell;
